// import Vue from "vue";
// import VueGoogleAutocomplete from "vue-google-autocomplete";
// Vue.use(VueGoogleAutocomplete);
// Vue.component("vue-google-autocomplete", VueGoogleAutocomplete);
